import {remCalc} from '_themeUtils'

const productStickybar = {
    ProductStickybar: {
        baseStyle: () => ({
            stickybarWrapper: {
                w: '100%',
                py: 'spacing.2',
                px: 'spacing.4',
                columnGap: 'spacing.4',
                border: '1px solid',
            },
            stickyName: {
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
            stickyColorSelector: {
                mr: 0,
                ml: 'auto',
            },
            stickyColourButton: {
                textStyle: 'paragraphSm',
                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            colourSelectorPopover: {
                w: {base: '100%', md: 'auto'},
                bottom: {base: 0, md: remCalc(10)},
                right: {base: 0, md: remCalc(0)},
                p: 'spacing.4',
                border: '1px solid rgba(0,0,0,0.2)',
                maxH: '70vh',
                overflow: 'auto',
            },
            // Figma "Color dots" outer box (24px). Two-ring visual handled by ColorCircle (`selected`).
            swatchItem: {
                position: 'relative',
                w: remCalc(24),
                h: remCalc(24),
                flexShrink: 0,
            },
            stickySizeSelector: {},
            stickyAddToCartWrapper: {
                w: remCalc(180),
            },
            sizeSelectorPopover: {
                w: {base: '100%', md: remCalc(500)},
                bottom: {base: 0, md: remCalc(30)},
                rigth: {base: 0, md: remCalc(30)},
                p: 'spacing.4',
                maxH: '70vh',
                overflow: 'auto',
                border: '1px solid',
                borderRadius: remCalc(8),
            },
            stickySizeButton: {
                textStyle: 'paragraphSm',
                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
        }),
    },
}

export default productStickybar
